import CodeMirror from 'codemirror';
import columnNames from './columns';

CodeMirror.defineMode('vbql', (config, parserConfig) => {
  const { atoms, keywords, operatorChars } = parserConfig;

  const columns = {
    ...columnNames.reduce((obj, name) => ({
      ...obj,
      [name.toLowerCase()]: true,
    }),
    {},
    ),
  };
  // Sorry, this is a rework of some very poor code we inherited on this project. It lacks
  // any form of inline comments to explain what the hell it does.
  function tokenBase(stream, state) {
    // 'string', with char specified in quote escaped by '\'
    function tokenLiteral(quote) {
      return (stream, state) => {
        let escaped = false;
        let ch;
        while ((ch = stream.next()) != null) {
          if (ch === quote && !escaped) {
            state.tokenize = tokenBase;
            break;
          }
          escaped = !escaped && ch == '\\';
        }
        return 'string';
      };
    }

    if (config.refRe && stream.match(config.refRe)) {
      return 'variable-2';
    }

    const ch = stream.next();
    switch (true) {
      case (ch.charCodeAt(0) > 47 && ch.charCodeAt(0) < 58): {
        // numbers
        // ref: http://dev.mysql.com/doc/refman/5.5/en/number-literals.html
        stream.match(/^[0-9]*(\.[0-9]+)?([eE][-+]?[0-9]+)?/);
        stream.match(/^\.(?!\.)/);
        return 'number';
      }
      case (ch === '?' && (stream.eatSpace() || stream.eol() || stream.eat(';'))): {
        // placeholders
        return 'variable-3';
      }
      case (ch === "'" || (ch === '"')): {
        // strings
        state.tokenize = tokenLiteral(ch);
        return state.tokenize(stream, state);
      }
      case (/^[\(\),\;\[\]]/.test(ch)): {
        // no highlighting
        return null;
      }
      case (ch === '/' && stream.eat('/')): {
        // 1-line comment
        stream.skipToEnd();
        return 'comment';
      }
      case (ch === '/' && stream.eat('*')): {
        // multi-line comments
        state.tokenize = tokenComment(1);
        return state.tokenize(stream, state);
      }
      case (operatorChars.test(ch)): {
        // operators
        stream.eatWhile(operatorChars);
        return null;
      }
      default: {
        stream.eatWhile(/^[_\w\d]/);
        const word = stream.current().toLowerCase();
        if (atoms[word]) return 'atom';
        if (columns[word]) return 'column';
        if (keywords[word]) return 'keyword';
        return null;
      }
    }
  }

  function tokenComment(depth) {
    return function (stream, state) {
      const m = stream.match(/^.*?(\/\*|\*\/)/);
      if (!m) stream.skipToEnd();
      else if (m[1] == '/*') state.tokenize = tokenComment(depth + 1);
      else if (depth > 1) state.tokenize = tokenComment(depth - 1);
      else state.tokenize = tokenBase;
      return 'comment';
    };
  }

  function pushContext(stream, state, type) {
    state.context = {
      prev: state.context,
      indent: stream.indentation(),
      col: stream.column(),
      type,
    };
  }

  function popContext(state) {
    state.indent = state.context.indent;
    state.context = state.context.prev;
  }

  return {
    startState() {
      return { tokenize: tokenBase, context: null };
    },

    token(stream, state) {
      if (stream.sol()) {
        if (state.context && state.context.align == null) { state.context.align = false; }
      }
      if (state.tokenize == tokenBase && stream.eatSpace()) return null;

      const style = state.tokenize(stream, state);
      if (style === 'comment') return style;

      if (state.context && state.context.align == null) { state.context.align = true; }

      const tok = stream.current();
      if (tok == '(') { pushContext(stream, state, ')'); } else if (tok == '[') { pushContext(stream, state, ']'); } else if (state.context && state.context.type == tok) { popContext(state); }
      return style;
    },

    blockCommentStart: '/*',
    blockCommentEnd: '*/',
    lineComment: '//',
  };
});

function set(str) {
  const obj = {};
  const words = str.split(' ');
  for (let i = 0; i < words.length; i += 1) obj[words[i].toLowerCase()] = true;
  return obj;
}

CodeMirror.defineMIME('text/x-vbql', {
  name: 'vbql',
  atoms: set('false true null current_date current_time current_timestamp'),
  keywords: set('match filter return select as from any all with slop create category with extended hits inline'),
  operatorChars: /^[*+\-%<>!=&|/~]/,
});

/*
  How Properties of Mime Types are used by SQL Mode
  =================================================

  atoms:
    Keywords that must be highlighted as atoms,. Some DBMS's support more atoms
    than others:
    UNKNOWN, INFINITY, UNDERFLOW, NaN...
  keywords:
    A list of keywords you want to be highlighted.
  operatorChars:
    All characters that must be handled as operators.
*/
